<template>
  <div class="col-12">
    <Search
      :dataNotExist="$lang.dataNotExist"
      :allowFields="$lang.research_manager_connection_fields"
      :url="url"
      :title="$lang.research_ready"
      ref="search"
      :hiddenFields="hiddenFields"
      :dynamicButtons="dynamicButtons"
      :showCheckBox="isAdmin(permissions)"
      :handleCheckBoxCondition="handleCheckBoxCondition"
      :filterCatch="true"
      :visibleAdd="false"
      :extraButtons="extraButtons"
      :itemTopHeader="itemTopHeader"
      :getColVariant="getColVariant"
      @getPermisson="updatePermissions"
      @rowSelected="rowSelected"
      @rowAllSelected="rowAllSelected"
      @countClicked="showSearches"
    />
    <b-modal
      no-close-on-backdrop
      v-model="view_modal"
      size="xl"
      hide-header
      hide-footer
    >
      <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
      <ResearchManagerConnectionForm
        :items="items"
        :title="parentViewModalTitle"
        v-show="!isLoading"
        @closeModal="closeModal"
        @submit="save"
      />
    </b-modal>
    <b-modal
      no-close-on-backdrop
      v-model="searchesModal"
      size="xl"
      hide-header
      hide-footer
    >
      <Search
        :allowCollapse="false"
        :url="searchesUrl"
        :title="$lang.research_list"
        :allowFields="$lang.researchLang.searches_fields"
        removeModalSize="xl"
        :filterCatch="false"
        :visibleSearch="false"
        :visibleSettings="false"
        :visibleExport="false"
        :visibleFilters="false"
        :visibleViewCount="false"
        :allowEdit="false"
        :visibleAdd="false"
        :showFilterBtn="false"
        :showCheckBox="false"
        :dynamicButtons="buttonsAddress"
        :parentPermissions="permissions"
        :itemTopHeader="searchesItemTopHeader"
        :getColVariant="getColVariantSearches"
        :remove_item="removeSearches"
        :handleCheckBoxCondition="handleCheckBoxCondition"
        @getPermisson="updateModalSearchPermissions"
      />
      <b-row>
        <b-col class="text-right mt-3">
          <b-button variant="outline-danger" @click="closeSearchesModal()">
            <mdicon name="close" size="20" />
            {{ $lang.close }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import ResearchManagerConnectionForm from "./../forms/researchManagerConnectionForm";
import Search from "@/components/base/search";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { includes, pathOr } from "ramda";
import { isAdmin, generateApiUrl, generateStoreGetters } from "@/shared/utils";

export default {
  name: "researchManagerConnectionSearch",
  components: {
    Search,
    ResearchManagerConnectionForm,
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      view_modal: false,
      personsSelected: [],
      permissions: [],
      modalPermissions: [],
      items: [],
      parentViewModalTitle: null,
      itemTopHeader: [
        {
          colspan: 7,
          name: this.$lang.audience_info,
        },
        {
          colspan: 5,
          name: this.$lang.num_research,
          variant: "info",
        },
      ],
      searchesModal: false,
      searchesUrl: null,
      buttonsAddress: [
        {
          id: "120",
          name: "searchesDelete",
          text: this.$lang.researchPlanAction,
        },
      ],
      searchesItemTopHeader: [
        {
          colspan: 7,
          name: this.$lang.researchLang.audience,
        },
        {
          colspan: 1,
          name: this.$lang.researchLang.research_manager,
          variant: "info",
        },
        {
          colspan: 1,
          name: this.$lang.researchLang.researcher,
          variant: "primary",
        },
      ],
      hiddenFields: [
        "created_at.jalali",
        "created_by",
        "updated_by",
        "updated_at",
      ],
    };
  },
  computed: {
    dynamicButtons() {
      const roles = generateStoreGetters(["userInfo", "roles"]) || [];
      return [
        {
          name: "default",
          text: this.$lang.insert_research,
          AllowPermissions: ["admin"],
          iconFont: {
            name: "account-arrow-right-outline",
            size: "25",
            class: "text-primary",
          },
          showIcon:
            includes("modir_arshad_tahghigh", roles) ||
            isAdmin(this.permissions),
          click: this.openModalOne,
        },
      ];
    },
    url() {
      return generateApiUrl(["research", "ready_research"]);
    },
    extraButtons() {
      return [
        {
          name: "insert_research_as_research",
          condition: this.personsSelected.length,
          title: this.$lang.assign_research_manager_group,
          click: this.openModalGroup,
          iconName: "account-switch-outline",
          badgeCondition: this.personsSelected.length,
          badgeText: this.personsSelected.length,
        },
      ];
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    async save(payload) {
      try {
        this.isLoading = true;
        const url =
          this.$config.api_url +
          this.$config.research.connect_research_manager_audience;
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.closeModal();
        this.personsSelected = [];
        this.$refs.search.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    researchStatusId(item) {
      return pathOr(null, ["research_status", "id"], item);
    },
    closeModal() {
      this.view_modal = false;
    },
    openModalOne(item) {
      this.personsSelected = [];
      this.items = [item];
      this.parentViewModalTitle = null;
      this.view_modal = true;
    },
    openModalGroup() {
      /* guidance: check term for all person selected */
      if (!this.checkTerms()) {
        return this.$notify.warning(
          "تمامی پرونده‌ها بایستی متعلق به یک دوره باشند"
        );
      }

      this.items = [...this.personsSelected];
      this.parentViewModalTitle = this.$lang.assign_research_manager_group;
      this.view_modal = true;
    },
    checkTerms() {
      /* guidance: check term for all person selected */
      const termCodeArr = this.personsSelected.map((item) => {
        return pathOr(null, ["audience", "parvandeh", "term", "code"], item);
      });
      const uniqueTermCodeArr = [...new Set(termCodeArr)];
      return uniqueTermCodeArr.length === 1;
    },
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
    updateModalSearchPermissions(permissions) {
      this.modalPermissions = [...permissions];
    },
    showSearches(item, countKey) {
      const search_txt = pathOr(
        null,
        ["audience", "parvandeh", "parvandeh_number"],
        item
      );
      const researchStatusId = pathOr(
        null,
        [countKey, "research_status_id"],
        item
      );
      const researchStatusCount = pathOr(null, [countKey, "count"], item);
      if (!researchStatusCount)
        return this.$notify.warning("این گزینه شامل هیچ رکوردی نمی باشد");
      const queryString = researchStatusId
        ? {
            search_txt,
            "research_status_id[]": researchStatusId,
          }
        : { search_txt };
      this.searchesUrl = generateApiUrl(
        ["research", "research_queue"],
        [],
        queryString
      );
      this.searchesModal = true;
    },
    closeSearchesModal() {
      this.searchesModal = false;
      this.searchesUrl = null;
    },
    async removeSearches(item) {
      const id = pathOr(null, ["id"], item);
      if (!id) return;
      try {
        this.searchesLoading = false;
        const url = generateApiUrl(["research", "research_queue_id"], [id]);
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.fillTable();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.searchesLoading = false;
      }
    },
    rowSelected(row) {
      const id = pathOr(null, ["audience", "parvandeh", "code"], row);
      const alreadySelected = this.personsSelected.find(
        (item) => pathOr(null, ["audience", "parvandeh", "code"], item) === id
      );
      if (alreadySelected) {
        this.personsSelected = [
          ...this.personsSelected.filter(
            (item) =>
              pathOr(null, ["audience", "parvandeh", "code"], item) !== id
          ),
        ];
      } else {
        this.personsSelected.push(row);
      }
    },
    rowAllSelected(rows) {
      this.personsSelected = [...rows];
    },
    getColVariant(index) {
      if (index <= 5) {
        return "";
      }
      if (index <= 10) {
        return "info";
      }
    },

    getColVariantSearches(index) {
      if (index <= 5) {
        return "";
      }
      if (index <= 6) {
        return "info";
      }
      if (index <= 7) {
        return "primary";
      }
    },
    handleCheckBoxCondition(item) {
      return true;
    },
  },
};
</script>
